jQuery(".tt-cart .tt-dropdown-menu").prepend(jQuery("<div class='cart-dropdown-btn'><span class='cart-dropdown-icon-btn'></span></div>"));

jQuery(".cart-dropdown-btn span.cart-dropdown-icon-btn").click(function () {
    jQuery(".tt-desctop-parent-cart .tt-cart").removeClass("active ");
});
jQuery(document).ready(function () {
    jQuery('p').each(function () {
        const jQuerythis = jQuery(this);
        if (jQuerythis.html().replace(/\s|&nbsp;/g, '').length === 0)
            jQuerythis.remove();
    });
});

// Faq Start
jQuery(document).ready(function () {
    jQuery('.faq-content').hide();
    jQuery('.faq-item.active .faq-content').show();
    jQuery(".faq .faq-item > button").click(function () {
        var clickedItem = jQuery(this).closest('.faq-item');
        if (clickedItem.hasClass('active')) {
            clickedItem.removeClass('active');
            clickedItem.find('.faq .faq-content').slideUp();
        } else {
            jQuery('.faq-item').removeClass("active");
            jQuery('.faq .faq-item .faq-content').slideUp();
            clickedItem.addClass("active");
            clickedItem.find('.faq .faq-item .faq-content').slideDown();
        }
    });
});

// Faq End

// Side Cart

jQuery(".small-header .tt-desktop-header .tt-header-holder .tt-dropdown-obj").append(jQuery("<div class='side_cart_open'></div>"));
setInterval(function () {
    if ($('.tt-cart').hasClass('active')) {
        $('body').addClass("animated");
    } else {
        $('body').removeClass("animated");
    }
});

//  Product Reels Section

jQuery(document).ready(function () {
  // category-section

jQuery('.category-collection').slick({
    infinite: true,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1661,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

    jQuery('.product-reels-slider').slick({
        asNavFor: '.product-model-slider',
        infinite: true,
        dots: false,
        arrows: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

jQuery(document).ready(function () {
    jQuery('.product-model-slider').slick({
        asNavFor: '.product-reels-slider',
        centerMode: true,
        variableWidth: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 300,
        autoplay: false,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

jQuery(document).ready(function () {
    jQuery('.product-reels-item').click(function () {
        jQuery("body").addClass("open-popup");
    });
    jQuery('.whatmore-shopping-close-button').click(function () {
        jQuery("body").removeClass("open-popup");
    });
});

// Shop Fabrics Collection

jQuery('.shop-fabrics-collection').slick({
    infinite: true,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 1500,
    ltr: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1661,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.product-reels-section .product-reels-slider .whatmore-event-tile-scale-in-animation').click(function(){
  setTimeout(function(){
    $('.product-model-slider').slick('refresh');
  }, 200);
});



jQuery(document).ready(function() {
  jQuery('.reels-popup svg').on('click', function() {
    jQuery('.reels-popup').hide();
  });
  jQuery('.reels-popup-overlay svg').on('click', function() {
    jQuery('.product .reels-popup-overlay').hide();
    jQuery('video.reels-video-popup').show();
  });
  jQuery(document).ready(function(){
      jQuery('video.reels-video-popup').on('click', function(){
          jQuery('.product .reels-popup-overlay').show();
          jQuery(this).hide();
      });
  });
  jQuery('.product .reels-popup-overlay').hide();

});

jQuery(document).ready(function() {
  var inputElement = jQuery('footer #contact_form .form-group input[type="number"]');
  inputElement.attr('maxlength', 10);
});

jQuery(document).ready(function() {
  jQuery( "ul.tt-social-icon" ).insertAfter( ".contact-details" );
  jQuery( ".footer_subscribe_form" ).insertAfter( ".tt-footer-type2" );
});

jQuery(document).ready(function() {
  jQuery('.hero-slider').slick({
    infinite: true,
    arrows: false,
    autoplay: true,
    dots: true
  });
});
jQuery(document).ready(function() {
  jQuery(".product_page_template .tt-product-single-info .shopify-payment-button__button").text("Buy now");
});

var mobileHeaderlogo = setInterval(() => {
    if (document.querySelector('.panel-menu li.mm-close-parent a.mm-close')) {
      clearInterval(mobileHeaderlogo);
      document.querySelector('.panel-menu li.mm-close-parent a.mm-close').insertAdjacentHTML('beforebegin',`<a class="p-0" src="/"><img class="d-block" src="https://skyparrow.com/cdn/shop/files/Skyparrow-logo_220x.svg" width="140"/></a>`);
    }
}, 100);
var buyButton = setInterval(() => {
    if (document.querySelector('.product_page_template .tt-product-single-info .shopify-payment-button__button')) {
      document.querySelector('.product_page_template .tt-product-single-info .shopify-payment-button__button').innerHTML = "Buy now";
    }
}, 100);
